import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { ImportRatesRequest, RateImportPaginationRequest } from '@/main/models/request';
import { ImportRatesResponse, RateImportResponse } from '@/main/models/response';

export abstract class IRateImportApi {
  abstract postImportRates(request: ImportRatesRequest, file: File): Promise<AxiosResponse<Result<ImportRatesResponse>>>;
  abstract getSearchGrid(request: RateImportPaginationRequest): Promise<AxiosResponse<PaginationResponse<RateImportResponse>>>;
  abstract getErrorMessage(guidRateImport: string): Promise<AxiosResponse<Result<any>>>;
  abstract downloadImportFile(guidFileImport: string): Promise<AxiosResponse<Result<any>>>;
}
